<ul class="list_menu">
  @if (isCustomBroker$$()) {
    <li>
      <a class="link_lnb" [routerLink]="['/broker-declaration']" routerLinkActive="lnb_link_open">
        <span class="txt_menu">Import Declaration</span>
      </a>
    </li>
  } @else {
    <li>
      <a class="link_lnb" [routerLink]="['/data-management']" routerLinkActive="lnb_link_open">
        <span class="txt_menu">Data Management</span>
      </a>
    </li>
    <li>
      <a class="link_lnb" [routerLink]="['/ai-scanning']" routerLinkActive="lnb_link_open">
        <span class="txt_menu">AI Scanning</span>
      </a>
    </li>
    <li>
      <a class="link_lnb" [routerLink]="['/cargo-tracking']" routerLinkActive="lnb_link_open">
        <span class="txt_menu">Cargo Tracking</span>
      </a>
    </li>
    <li
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }"
      #warehouseRla="routerLinkActive"
      [class.menu_expanded]="warehouseMenuIsActive$$()"
    >
      <a
        class="link_lnb"
        [class.active]="warehouseRla.isActive"
        (click)="toggleMenu('warehouse'); $event.preventDefault()"
      >
        <span class="txt_menu">Warehouse Management</span>
        @if (warehouseMenuIsActive$$()) {
          <span class="ico_chevron_up"></span>
        } @else {
          <span class="ico_chevron_down"></span>
        }
      </a>
      <ul class="list_menu_depth">
        <li>
          <a [routerLink]="['/warehouse-management']" routerLinkActive="depth_link_open">
            <span>Inbound / Outbound Order</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/inventory-management']" routerLinkActive="depth_link_open">
            <span>Inventory</span>
          </a>
        </li>
      </ul>
    </li>
    @if (!isE2e) {
      <li
        routerLinkActive="active-link"
        [routerLinkActiveOptions]="{ exact: true }"
        #customsRla="routerLinkActive"
        [class.menu_expanded]="customsMenuIsActive$$()"
      >
        <a
          class="link_lnb"
          [class.active]="customsRla.isActive"
          (click)="toggleMenu('customs'); $event.preventDefault()"
        >
          <span class="txt_menu">Customs Management</span>
          @if (customsMenuIsActive$$()) {
            <span class="ico_chevron_up"></span>
          } @else {
            <span class="ico_chevron_down"></span>
          }
        </a>
        <ul class="list_menu_depth">
          <li>
            <a [routerLink]="['/shipper-declaration']" routerLinkActive="depth_link_open">
              <span>Import Declaration</span>
            </a>
          </li>
          <li>
            <a [routerLink]="['/case']" routerLinkActive="depth_link_open">
              <span>Similar Cases</span>
            </a>
          </li>
          <li>
            <a [routerLink]="['/statistics']" routerLinkActive="depth_link_open">
              <span>Analytics</span>
            </a>
          </li>
        </ul>
      </li>
    }
    <li
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }"
      #userRla="routerLinkActive"
      [class.menu_expanded]="userMenuIsActive$$()"
    >
      <a class="link_lnb" [class.active]="userRla.isActive" (click)="toggleMenu('user'); $event.preventDefault()">
        <span class="txt_menu">User Setting</span>
        @if (userMenuIsActive$$()) {
          <span class="ico_chevron_up"></span>
        } @else {
          <span class="ico_chevron_down"></span>
        }
      </a>
      <ul class="list_menu_depth">
        <li>
          <a [routerLink]="['/link-editor']" routerLinkActive="depth_link_open">
            <span>Document Link</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/freetime/management']" routerLinkActive="depth_link_open">
            <span>Freetime</span>
          </a>
        </li>
      </ul>
    </li>
  }
</ul>
